import React from 'react';
import { Box, useTheme, alpha } from '@mui/material';
import SideMenu from './SideMenu';
import { useDeviceDetect } from '../util/deviceDetect';
import WebBankTable from './WebBankTable';

const WebLayout = ({ children }) => {
  const theme = useTheme();
  const { isMobile } = useDeviceDetect();
  const darkMode = theme.palette.mode === 'dark';

  // Professional dark green color scheme
  const colors = {
    background: darkMode ? '#0F1419' : '#F8FAFC',
    paper: darkMode ? '#1F2937' : '#FFFFFF',
    border: darkMode ? alpha('#374151', 0.8) : alpha('#94A3B8', 0.12),
    divider: darkMode ? alpha('#374151', 0.6) : alpha('#94A3B8', 0.08),
    text: {
      primary: darkMode ? '#F9FAFB' : '#0F172A',
      secondary: darkMode ? '#9CA3AF' : '#64748B',
      tertiary: darkMode ? alpha('#9CA3AF', 0.7) : alpha('#64748B', 0.7),
    },
    action: {
      hover: darkMode ? alpha('#065F46', 0.12) : alpha('#065F46', 0.04),
      selected: darkMode ? alpha(theme.palette.primary.main, 0.16) : alpha(theme.palette.primary.main, 0.08),
      selectedHover: darkMode ? alpha(theme.palette.primary.main, 0.24) : alpha(theme.palette.primary.main, 0.12),
    }
  };

  if (isMobile) {
    return children;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: '280px 1fr',
        minHeight: '100vh',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
        m: 0,
        p: 0,
        bgcolor: colors.background,
      }}
    >
      <Box
        sx={{
          gridColumn: '1',
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          bgcolor: theme.palette.background.paper,
          position: 'sticky',
          top: 0,
          m: 0,
          p: 0,
        }}
      >
        <SideMenu colors={colors} />
      </Box>

      <Box
        component="main"
        sx={{
          gridColumn: '2',
          minHeight: '100vh',
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          bgcolor: colors.background,
          m: 0,
          p: 0,
          '& .MuiContainer-root': {
            maxWidth: '100% !important',
            width: '100%',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            padding: '0 !important',
            margin: '0 !important'
          }
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default WebLayout; 